var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-radio-group",
    {
      staticClass: "currency-tab-item",
      model: {
        value: _vm._value,
        callback: function ($$v) {
          _vm._value = $$v
        },
        expression: "_value",
      },
    },
    _vm._l(_vm.options, function (item, index) {
      return _c(
        "el-radio",
        { key: index, attrs: { label: item } },
        [
          _c("svg-icon", {
            attrs: { "icon-class": _vm.getFlagIconName(item) },
          }),
          _c("b", [_vm._v(_vm._s(item))]),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }